"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var theme_1 = __importDefault(require("../../../../theme"));
var hooks_1 = require("../../hooks");
var Drag_1 = __importDefault(require("../../../../icons/Drag"));
var Trash_1 = __importDefault(require("../../../../icons/Trash"));
var styles_1 = require("./styles");
var MultiImagePickerThumb = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var image = _a.image, style = _a.style, className = _a.className;
    var removeImage = (0, hooks_1.useMultiImagePicker)().removeImage;
    return (react_1.default.createElement(styles_1.Container, { ref: ref, className: className, style: style === null || style === void 0 ? void 0 : style.container },
        react_1.default.createElement(styles_1.IconsContainer, { onClick: function () { return removeImage(image); } },
            react_1.default.createElement(Drag_1.default, { color: theme_1.default.colorsPalette.white.default, height: "14px" }),
            react_1.default.createElement(Trash_1.default, { color: theme_1.default.colorsPalette.white.default, height: "14px" })),
        react_1.default.createElement(styles_1.ThumbContainer, null,
            react_1.default.createElement(styles_1.Image, { src: ((_b = image.file) === null || _b === void 0 ? void 0 : _b.preview) || image.url, style: style === null || style === void 0 ? void 0 : style.image })),
        react_1.default.createElement(styles_1.HoverContainer, null)));
});
exports.default = MultiImagePickerThumb;
//# sourceMappingURL=index.js.map